import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path } from "react-native-svg";

export default function GoogleIcon(props) {
  const width = props.width || 60;
  const height = props.height || 60;

  return (
    <TouchableOpacity style={props.style} {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 31 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.6398 16.2041C24.6398 15.566 24.5825 14.9524 24.4762 14.3633H16V17.8446H20.8435C20.6349 18.9695 20.0008 19.9227 19.0477 20.5609V22.819H21.9562C23.658 21.2522 24.6398 18.945 24.6398 16.2041Z"
          fill="#4285F4"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.001 24.9998C18.431 24.9998 20.4682 24.1939 21.9573 22.8194L19.0487 20.5613C18.2428 21.1013 17.2119 21.4203 16.001 21.4203C13.657 21.4203 11.673 19.8372 10.9652 17.71H7.9585V20.0417C9.43937 22.983 12.4829 24.9998 16.001 24.9998Z"
          fill="#34A853"
        />
        <Path 
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.964 17.7097C10.784 17.1697 10.6817 16.5929 10.6817 15.9997C10.6817 15.4066 10.784 14.8298 10.964 14.2898V11.958H7.95725C7.34772 13.173 7 14.5475 7 15.9997C7 17.452 7.34772 18.8265 7.95725 20.0415L10.964 17.7097Z"
          fill="#FBBC05"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.001 10.5795C17.3224 10.5795 18.5087 11.0335 19.4414 11.9253L22.0227 9.34404C20.4641 7.8918 18.4269 7 16.001 7C12.4829 7 9.43937 9.01677 7.9585 11.9581L10.9652 14.2898C11.673 12.1626 13.657 10.5795 16.001 10.5795Z"
          fill="#EA4335"
        />
      </Svg>
    </TouchableOpacity>
  );
}
